import { render, staticRenderFns } from "./MyPhone.vue?vue&type=template&id=9f5086d2&scoped=true&"
import script from "./MyPhone.vue?vue&type=script&lang=js&"
export * from "./MyPhone.vue?vue&type=script&lang=js&"
import style0 from "./MyPhone.vue?vue&type=style&index=0&id=9f5086d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5086d2",
  null
  
)

export default component.exports